import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Calendar, Users, Award } from 'lucide-react';

const PoliticalCareerSection = () => {
  const timelineEvents = [
    {
      year: "2000-2019",
      title: "Carrière dans l'administration",
      description: "Inspecteur des finances publiques, expertise en gestion budgétaire et fiscalité",
      icon: <CheckCircle className="w-5 h-5" />,
      color: "bg-primary"
    },
    {
      year: "2014",
      title: "Rencontre avec Ousmane Sonko",
      description: "Début de l'engagement politique et adhésion aux idéaux de transformation",
      icon: <Users className="w-5 h-5" />,
      color: "bg-secondary"
    },
    {
      year: "2019",
      title: "Création du PASTEF",
      description: "Co-fondateur et secrétaire général du parti PASTEF",
      icon: <Award className="w-5 h-5" />,
      color: "bg-accent"
    },
    {
      year: "2021-2023",
      title: "Structuration du parti",
      description: "Développement de la doctrine politique et organisation territoriale",
      icon: <CheckCircle className="w-5 h-5" />,
      color: "bg-primary"
    },
    {
      year: "2024",
      title: "Candidature présidentielle",
      description: "Candidat du PASTEF après la disqualification d'Ousmane Sonko",
      icon: <Calendar className="w-5 h-5" />,
      color: "bg-secondary"
    },
    {
      year: "2 avril 2024",
      title: "Élection à la Présidence",
      description: "Élu 5ème Président de la République du Sénégal au premier tour",
      icon: <Award className="w-5 h-5" />,
      color: "bg-accent"
    }
  ];

  const achievements = [
    {
      title: "Expertise financière",
      description: "Plus de 15 ans d'expérience dans l'inspection des finances publiques",
      badge: "Compétence"
    },
    {
      title: "Leadership politique",
      description: "Secrétaire général du PASTEF, architecte de la doctrine du parti",
      badge: "Organisation"
    },
    {
      title: "Vision transformatrice",
      description: "Porteur d'un projet de rupture et de souveraineté nationale",
      badge: "Innovation"
    },
    {
      title: "Légitimité populaire",
      description: "Élu au premier tour avec une large majorité",
      badge: "Démocratie"
    }
  ];

  return (
    <section id="parcours" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* En-tête de section */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
              Parcours Politique
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              De l'administration publique à la Présidence : un parcours exemplaire 
              au service de la nation sénégalaise.
            </p>
          </div>

          {/* Chronologie interactive */}
          <div className="mb-16">
            <h3 className="text-2xl font-semibold text-center mb-12 text-primary">
              Chronologie du parcours
            </h3>
            <div className="relative">
              {/* Ligne de temps */}
              <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-primary via-secondary to-accent rounded-full"></div>
              
              {/* Événements */}
              <div className="space-y-12">
                {timelineEvents.map((event, index) => (
                  <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                    <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                      <Card className="shadow-card hover:shadow-elegant transition-all duration-300 transform hover:-translate-y-1">
                        <CardContent className="p-6">
                          <div className="flex items-center gap-2 mb-2">
                            <Badge variant="secondary" className="text-xs font-semibold">
                              {event.year}
                            </Badge>
                          </div>
                          <h4 className="text-lg font-semibold text-primary mb-2">
                            {event.title}
                          </h4>
                          <p className="text-muted-foreground text-sm">
                            {event.description}
                          </p>
                        </CardContent>
                      </Card>
                    </div>
                    
                    {/* Icône centrale */}
                    <div className={`w-12 h-12 ${event.color} rounded-full flex items-center justify-center text-white shadow-lg z-10 relative`}>
                      {event.icon}
                    </div>
                    
                    <div className="w-1/2"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Réalisations clés */}
          <div>
            <h3 className="text-2xl font-semibold text-center mb-12 text-primary">
              Compétences et réalisations
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              {achievements.map((achievement, index) => (
                <Card key={index} className="shadow-card hover:shadow-elegant transition-all duration-300 transform hover:-translate-y-1">
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <h4 className="text-lg font-semibold text-primary">
                        {achievement.title}
                      </h4>
                      <Badge variant="outline" className="text-xs">
                        {achievement.badge}
                      </Badge>
                    </div>
                    <p className="text-muted-foreground">
                      {achievement.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PoliticalCareerSection;